import { PencilLine } from "lucide-react";
import { fmtDateTime } from "../../../lib/adminApi";

const LABELS = { profiles: "Profile", family_details: "Family", partner_preferences: "Partner preferences", profile_private_details: "Private details" };
const show = (v) => (v === null || v === undefined || v === "" ? "—" : typeof v === "object" ? JSON.stringify(v) : String(v));

export function PendingEdits({ edits }) {
  if (!edits.length) return null;
  return (
    <section data-testid="pending-edits" className="rounded-xl border-2 border-[#D4AF37] bg-[#F5E6BA]/30 p-5">
      <h3 className="flex items-center gap-2 font-display text-2xl font-semibold text-[#7A0016]"><PencilLine className="h-5 w-5" /> Changes made by the client</h3>
      <div className="mt-4 space-y-4">
        {edits.map((e) => (
          <div key={e.id} className="overflow-x-auto rounded-lg bg-white p-3">
            <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-[#8C6A6C]">{LABELS[e.table_name] || e.table_name} · {fmtDateTime(e.created_at)}</p>
            <table className="w-full min-w-[420px] text-sm">
              <thead className="text-left text-xs text-[#8C6A6C]"><tr><th className="py-1">Field</th><th>Before</th><th>After</th></tr></thead>
              <tbody>
                {Object.entries(e.changes).map(([field, ch]) => (
                  <tr key={field} className="border-t border-[#D4AF37]/20">
                    <td className="py-1.5 pr-3 font-medium">{field.replace(/_/g, " ")}</td>
                    <td className="pr-3 text-[#A31828] line-through">{show(ch.old)}</td>
                    <td className="font-semibold text-emerald-700">{show(ch.new)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </section>
  );
}
